module.exports = __webpack_public_path__ + "static/img/ShopCalendar.0aa5328.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ShopCalendar.png
// module id = ohg4
// module chunks = 1